import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import {Observable, catchError, finalize, switchMap, throwError, BehaviorSubject} from 'rxjs';
import { AuthService } from '@services/auth/auth.service';
import {filter, take} from "rxjs/operators";
import { CustomModalService } from '@services/modal/custom-modal.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';

@Injectable()
export class RefreshTokenInterceptor implements HttpInterceptor {
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  private isRefreshing = false;
  constructor(private notification: NzNotificationService,
              private customModalService: CustomModalService,
              private authService: AuthService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (request.url.includes('auth/token') || request.url.includes('auth/login')) {
      return next.handle(request);
    }
    return next.handle(request).pipe(
      catchError(error => {
        if (error.status === 401 ){
          // this.customModalService.close(); // temporary comment out for detect error occur
          // this.notification.remove(); // temporary comment out for detect error occur
          if(!this.isRefreshing){
            this.isRefreshing=true;
            this.refreshTokenSubject.next(null);
            return this.authService.refreshToken().pipe(
              switchMap(refreshResponse => {
                this.isRefreshing=false;
                if (refreshResponse) {
                  this.refreshTokenSubject.next(refreshResponse.access_token);
                  return next.handle(this.addAccessToken(request,refreshResponse.access_token));
                } else {
                  this.authService.logout();
                  // return throwError(() => error); //commented because: unwanted error message pop up although in login page.
                }
              })
            );
          }else{
            return this.refreshTokenSubject.pipe(
              filter(token => token != null),
              take(1),
              switchMap(jwt => {
                return next.handle(this.addAccessToken(request, jwt));
              }));
          }
        }else{
          return throwError(() => error);
        }
      })
    );
  }

  private addAccessToken(request: HttpRequest<unknown>, token: string): HttpRequest<unknown> {
    if (token) {
      return request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    }
    return request;
  }
}
